import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { ConfirmationDialogPropsType } from './ConfirmationDialog.types';

export function ConfirmationDialog(props: ConfirmationDialogPropsType) {
  const {
    text,
    title = 'Confirm Action',
    labelButton = 'OK',
    isConfirmationOpen,
    toggleConfirmationOpen,
    handleApproveConfirm,
  } = props;
  return (
    <Dialog open={isConfirmationOpen} onClose={toggleConfirmationOpen} maxWidth='xs' fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleConfirmationOpen}>Cancel</Button>
        <Button onClick={handleApproveConfirm} autoFocus>
          {labelButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
